import React from 'react';
import {toastr} from 'react-redux-toastr'
import {Collapse, Button, Card, CardBlock} from "reactstrap";
import {SubmissionError} from 'redux-form'
import {apiErrorsTransform} from '../utils'
import i18n from "./../i18n/i18n"

class ToastrMoreInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false
        }
    }

    handleToggle = () => {
        const {isOpen} = this.state;
        this.setState({
            isOpen: !isOpen
        })
    };

    render() {
        const {isOpen} = this.state;

        return <div className="show-more">
            {!isOpen && <Button color="link" onClick={this.handleToggle}>Zobrazit podrobnosti</Button>}
            <Collapse isOpen={isOpen}>
                {this.props.children}
            </Collapse>
        </div>
    }
}

const process200 = (e, resolve, reject) => {
    //const contentType = e.headers.get('Content-Type'); TODO json a text a další při správných datech
    //const contentLength = e.headers.get('Content-Length');
    //if (contentType && contentType.indexOf('application/json') === 0) {} else if (contentLength && contentLength == 0) {}

    const contentType = e.headers.get('content-type');

    e.text()
        .then(text => {
            if (contentType && contentType.toLowerCase().indexOf("application/json") >= 0) {
                if (text && text.length > 0) {
                    try {
                        const json = JSON.parse(text);
                        resolve(json);
                    } catch (err) {
                        console.error("err #1", e.url, err, e);
                        reject(err);
                    }
                } else {
                    resolve(null);
                }
            } else {
                resolve(text);
            }
        })
        .catch(err => {
            console.error("err #1", e.url, err, e);
            reject(e);
        });
};

function showErrorMessage(errorTypeText, message) {
    if (message && message.length > 0) {
        toastr.error(errorTypeText, message, {timeOut: 100000});
    } else {
        toastr.error(errorTypeText, null, {timeOut: 100000});
    }
}

const knownProps = {
    "message": null,
    "id": "Id záznamu",
    "kod": "Kód záznamu",
    "code": "Kód záznamu",
    "typ": "Typ záznamu",
    "type": "Typ záznamu",
    "systemMessage": "Systémová chyba",
};
/** Seznam proměnných, které budou implicitně zavbalené. */
const hiddenProps = {
    "systemMessage": true,
};

function getLabel(key) {
    let label;
    if (typeof knownProps[key] === 'undefined') {
        label = key;
    } else {
        label = knownProps[key];
    }
    return label;
}

function showAbstractExceptionMessage(ex) {
    const label = ex.message;
    const toastrProps = {};

    let altMessages = []; // dopňující zpráva
    let showMoreDetails;
    if (Object.keys(ex.properties).length > 0) {    // Doplňující informace
        let messageDetails = []; // další doplňující informace
        // Základní doplňující informace
        Object.keys(ex.properties).forEach(key => {
            const usekey = key[0] === '#' ? key.substring(1) : key;
            if (key[0] === "#" || typeof knownProps[usekey] !== 'undefined') { // zobrazíme ji prioritně uživateli
                if (typeof knownProps[usekey] !== 'undefined' && !knownProps[usekey]) { // nemá label
                    const add = hiddenProps[usekey] ? messageDetails : altMessages;
                    add.push(<div>{ex.properties[key]}</div>)
                } else {
                    const add = hiddenProps[usekey] ? messageDetails : altMessages;
                    add.push(
                        <dl className="row">
                            <dt className="col-12">{getLabel(usekey)}:</dt>
                            <ds className="col-12">{ex.properties[key]}</ds>
                        </dl>
                    );
                }
            } else {    // doplňující hláška, zobrazíme na rozbalení
                const add = hiddenProps[usekey] ? messageDetails : altMessages;
                add.push(
                    <dl className="row">
                        <dt className="col-12">{getLabel(usekey)}:</dt>
                        <ds className="col-12">{ex.properties[key]}</ds>
                    </dl>
                );
            }
        });

        // Object.keys(knownProps).forEach(key => {
        //     if (typeof ex.properties[key] !== 'undefined') {    // známá hláška, zobrazíme přednostně uživateli
        //         if (!knownProps[key]) { // nemá label, půjde do obecných zpráv
        //             altMessages.push(<div>{ex.properties[key]}</div>)
        //         } else {
        //             let label;
        //             let value = ex.properties[key];
        //             if (typeof knownProps[key] === 'undefined') {
        //                 label = key;
        //             } else {
        //                 label = knownProps[key];
        //             }
        //             messageDetails.push(<div>
        //                 <dl className="row">
        //                     <dt className="col-12">{label}:</dt>
        //                     <ds className="col-12">{value}</ds>
        //                 </dl>
        //             </div>)
        //         }
        //     } else {
        //
        //     }
        // });

        if (messageDetails.length > 0) {
            showMoreDetails = <ToastrMoreInfo>{messageDetails}</ToastrMoreInfo>;
        }
    }

    let showToastr;
    let show = true;
    switch (ex.level) {
        case "DANGER":
            showToastr = toastr.error;
            toastrProps.timeOut = 0;
            toastrProps.removeOnHover = false;
            // show = false;   // POUZE pro prezentaci TODO [stanekpa] - odebrat po prezentaci!
            break;
        case "WARNING":
            showToastr = toastr.warning;
            toastrProps.timeOut = 0;
            toastrProps.removeOnHover = false;
            break;
        case "INFO":
            showToastr = toastr.info;
            break;
        case "SUCCESS":
            showToastr = toastr.success;
            break;
    }

    if (altMessages.length > 0 || showMoreDetails) {
        toastrProps.timeOut = 0;
        toastrProps.removeOnHover = false;

        toastrProps.component = <div>
            {altMessages}
            {showMoreDetails}
        </div>
    }

    if (show) {
        showToastr(label, toastrProps);
    }
}

const processDefault = (e, resolve, reject, globalErrorResolverEnabled) => {
    console.error("err #3", e.url, e.statusText, e);

    let errorTypeText;
    switch (e.status) {
        case 500:
        case 404:
            errorTypeText = i18n(`global.json.error.${e.status}`);
            break;
        default:
            errorTypeText = i18n(`global.json.error.unknown`);
            break;
    }

    if (globalErrorResolverEnabled) {
        let contentType = e.headers.get('Content-Type');
        if (contentType && contentType.indexOf('application/json') === 0) {
            e.json()
            .then(message => showAbstractExceptionMessage(message))
            .catch(() => showErrorMessage(errorTypeText, null));
        } else {
            e.text()
            .then(message => showErrorMessage(errorTypeText, message))
            .catch(() => showErrorMessage(errorTypeText, null));
        }
    }

    reject(e);
};

const process422 = (e, resolve, reject) => {
    e.json()
        .then(errorData => {
            const errorInfo = {
                validation: true,
                errors: errorData.errors
            };
            reject(new SubmissionError(apiErrorsTransform(errorInfo.errors)));
        })
        .catch(err => {
            console.error("err #4", e.url, e.statusText, e, err);
            reject(e);
        })
};

/**
 * Vykoná middleware funkce k vlastnímu zpracování response ze serveru.
 * @param {object} e response
 * @param {array} resolveMiddlewareList pole funkcí ke zpracování response
 * @returns {(object|Array)} pokud se vykoná middleware funkce a po její vykonání není vhodné pokračovat se zpracováním response, tak se vrátí null.
 */
function processMiddlewareList(e: Object, resolveMiddlewareList:Array<Function>): Object | null {
    let response = e;
    for (let middleware of resolveMiddlewareList) {
        if ( typeof middleware === "function") {
            response = middleware(response);
            if (!response) {
                return null;
            }
        } else {
            console.error("resolveMiddleware není funkce", e.url, e.statusText, e);
        }
    }
    return response;
}

let _resolveMiddlewareList = [];

export default class ErrorApi {

    /**
     * Přidá middleware funkci do pole _resolveMiddlewareList
     * @param {function} resolveMiddlewareCallback pokud není potřeba response zpracovávat dále (např. nahrazuje stávající process funkci),
     * měla by tato funkce vrátit null jinak by měla vracet response.
     *
     */
    static addResolveMiddleware(resolveMiddlewareCallback:(e: Object | null) => Object | null){
        _resolveMiddlewareList.push(resolveMiddlewareCallback);
    }

    /**
     * Zpracuje Promise z volání fetch().
     *
     * @param {Promise} promise - výsledek volání fetch()
     * @param {boolean} globalErrorResolverEnabled - true pro zapnutí vyhodnocení případné chyby pomocí globálního resolveru
     * @returns {Promise} výsledný promise
     */
    static responseResolver(promise, globalErrorResolverEnabled = true) {
        return new Promise((resolve, reject) => {
            promise
                .then(e => {
                    const res = processMiddlewareList(e, _resolveMiddlewareList);
                    if (res) {
                        switch (res.status) {
                            case 200:
                                process200(res, resolve, reject);
                                break;
                            case 422:
                                process422(res, resolve, reject);
                                break;
                            default:
                                processDefault(res, resolve, reject, globalErrorResolverEnabled);
                                break;
                        }
                    }
                })
                .catch(e => {
                    //TODO doplnit toaster
                    reject(e);
                })

        });
    }
}
























// const ErrorComponent = (props) => <div>
//     <ControlLabel> Kód:</ControlLabel>   <pre> {props.code}</pre>
//     <ControlLabel> Soubor:</ControlLabel><pre> {props.file}</pre>
//     <ControlLabel> Řádka:</ControlLabel> <pre> {props.line}</pre>
//     <ControlLabel> Zpráva:</ControlLabel><pre> {props.message}</pre>
// </div>;
//
// const PartialErrorComponent = (props) => <div>
//         {props.code !== null && props.code !== undefined && <div>
//             <ControlLabel> Kód:</ControlLabel><pre> {props.code}</pre>
//         </div>}
//         {props.file !== null && props.file !== undefined && <div>
//             <ControlLabel> Soubor:</ControlLabel><pre> {props.file}</pre>
//         </div>}
//         {props.line !== null && props.line !== undefined && <div>
//             <ControlLabel> Řádka:</ControlLabel><pre> {props.line}</pre>
//         </div>}
//         {props.message !== null && props.message !== undefined && <div>
//             <ControlLabel> Zpráva:</ControlLabel><pre> {props.message}</pre>
//         </div>}
// </div>;
//
// const JSON_ERROR = (error) => {
//     console.error(error);
//     toastr.error(T.simpleMessage('Fatal error'), T.simpleMessage('Error in call'));
// };
// const jsonAction = (e, action) => {
//     // e.json()
//     //     .then((json) => {
//     //         // console.log(json);
//     //         return action(json)
//     //     })
//     //     .catch(JSON_ERROR);
//     e.text()
//         .then(text => {
//             if (text && text.length > 0) {
//                 try {
//                     const json = JSON.parse(text)
//                     action(json);
//                 } catch (err) {
//                     JSON_ERROR(err);
//                 }
//             } else {
//                 action(null);
//             }
//         })
//         .catch(JSON_ERROR);
// };
// const communicationError = () => toastr.error(T.simpleMessage('Fatal error'), T.simpleMessage('Error in communication'));
//
// /*export default */class ErrorApi2 {
//
//     static responseResolver(promise, globalErrorResolver = true) {
//         return new Promise((resolve, reject) => {
//             try {
//                 promise.then((e) => {
//                     if (e.status) {
//                         switch (e.status) {
//                             case 500:
//                                 if (globalErrorResolver) {
//                                     jsonAction(e, (json) => {
//                                         if(json.hasErrors && json.errors && json.errors.length) {
//                                             toastr.error('Chyba', {
//                                                 component: ( < div> {json.errors[0].message} <br/> <Button
//                                                     color="link"
//                                                     className="text-white"
//                                                     onClick={() => toastr.message('Více', {
//                                                             timeout: 0,
//                                                             component: <div>{json.errors.map(ErrorComponent)}</div>
//                                                         })
//                                                     }>Více...</Button></div>)
//                                             })
//                                         } else if (json.name) {
//                                             toastr.error('Chyba', {
//                                                 component: <div>{json.message}<br /><Button
//                                                     color="link"
//                                                     className="text-white"
//                                                     onClick={() => toastr.message('Více', {
//                                                         timeout: 0,
//                                                         component: PartialErrorComponent(json)
//                                                     })}>Více...</Button>
//                                                 </div>
//                                             })
//                                         }
//                                     });
//                             } else {
//                                 jsonAction(e, reject);
//                             }
//                             break;
//                         case 200:
//                             jsonAction(e, resolve);
//                             break;
//                         default:
//                             if (globalErrorResolver) {
//                                 communicationError()
//                             } else {
//                                 jsonAction(e, reject);
//                             }
//                         }
//                     }
//                 });
//             } catch (e) {
//                 if (globalErrorResolver) {
//                     communicationError();
//                 } else {
//                     reject(e);
//                 }
//             }
//         });
//     }
// }
